import React from 'react';

import {BackendSourceOptions, discoveryTracker} from '@udemy/browse-event-tracking';
import {useUDData} from '@udemy/ud-data';

import {TopicCard} from '../topic-card/topic-card.react-component';
import {EnrichedSkills} from './enriched-skills.react-component';
import {useMarketingSplitCardsData} from './hooks/useLocaleContentfulData';

export const EnrichedSkillsContainer = () => {
    const {request} = useUDData();
    const locale = request?.locale || 'en_US';
    const {header, cards} = useMarketingSplitCardsData(locale);

    const onClick = (card: {title: string; url: string; image: {url: string}}, index: number) => {
        discoveryTracker.trackDiscoveryItemClickEvent(
            {
                item: {
                    id: index,
                    title: card.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    const onImpression = (
        card: {title: string; url: string; image: {url: string}},
        index: number,
    ) => {
        discoveryTracker.trackDiscoveryImpression(
            {
                item: {
                    id: index,
                    title: card.title,
                    type: 'course_topic',
                },
            },
            {
                backendSource: 'discovery' as BackendSourceOptions,
                index: index,
                uiRegion: 'learn_essential_skills',
            },
        );
    };

    return (
        <EnrichedSkills title={header?.headline} subtitle={header?.supportingText || undefined}>
            {cards.map((card, i: number) => (
                <TopicCard
                    key={`topic-card-${i}`}
                    title={card.title}
                    href={card.url}
                    num_enrollments={0} // GraphQL data doesn't have learners, using fallback
                    backgroundImageUrl={card.image?.url}
                    onClick={() => onClick(card, i)}
                    trackImpression={() => onImpression(card, i)}
                />
            ))}
        </EnrichedSkills>
    );
};
